import flow from 'lodash/flow';
import { configuratorReducer } from '@gcc/configurator';
import countertopsConfiguratorReducer from './countertops-extension';

// curry right
const baseConfiguratorReducer = (action) => (state) => configuratorReducer(state, action);

export default (state, action) => flow(
  // run through standard configurator reducer
  baseConfiguratorReducer(action),
  // run through extended reducer(s)
  countertopsConfiguratorReducer(action),
)(state);
